import { render, staticRenderFns } from "./EventManagerSidebar.vue?vue&type=template&id=d34b832e&"
import script from "./EventManagerSidebar.vue?vue&type=script&lang=js&"
export * from "./EventManagerSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports